module.exports = __webpack_public_path__ + "img/bpay_dia.png";